export { default as cityDomain } from './city/city.domain';
export { default as roomTypesDomain } from './roomTypes/roomTypes.domain';
export { default as buildingDomain } from './building/building.domain';
export { default as portfolioDomain } from './portfolio/portfolio.domain';
export { default as marketingDomain } from './marketing/marketing.domain';
export { default as contactUsDomain } from './contactUs/contact-us.domain';
export { default as agentDomain } from './agent/agent.domain';
export { default as preBookingDomain } from './preBooking/preBooking.domain';
export { default as accountDomain } from './account/account.domain';
export { default as paymentDomain } from './payment/payment.domain';